import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f5f1e8]">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-[#e8dfd0] sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 
            onClick={() => navigate('/')}
            className="text-2xl font-light cursor-pointer hover:text-[#6b5d4f] transition-colors duration-200" 
            style={{ fontFamily: 'Georgia, serif', color: '#4a3f33' }}
          >
            게임기획자 해든의 낙서
          </h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="bg-white/60 border border-[#e8dfd0] rounded-lg p-8 md:p-12">
          <h1 className="text-3xl font-light text-[#4a3f33] mb-8" style={{ fontFamily: 'Georgia, serif' }}>
            개인정보처리방침
          </h1>

          <div className="space-y-8 text-[#4a3f33]">
            <section>
              <p className="text-sm text-[#7a6d5f] mb-6 leading-relaxed">
                게임기획자 해든의 낙서(이하 "본 사이트")는 이용자의 개인정보를 중요시하며, 「개인정보 보호법」을 준수하고 있습니다.
                본 개인정보처리방침은 본 사이트가 제공하는 서비스 이용 시 수집되는 개인정보의 항목, 이용 목적, 보유 및 이용 기간 등에 관한 사항을 안내합니다.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                1. 수집하는 개인정보의 항목
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-3">
                <p>본 사이트는 기본적으로 별도의 회원가입 절차 없이 대부분의 콘텐츠를 자유롭게 열람하실 수 있습니다.</p>
                <p className="font-medium text-[#4a3f33]">가. 문의하기 양식 작성 시</p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>필수항목: 이메일 주소, 문의 내용</li>
                  <li>선택항목: 이름 또는 닉네임</li>
                </ul>
                <p className="font-medium text-[#4a3f33] mt-4">나. 자동 수집 정보</p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>접속 로그, IP 주소, 쿠키, 방문 일시, 서비스 이용 기록</li>
                  <li>기기 정보(OS, 브라우저 종류 등)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                2. 개인정보의 수집 및 이용 목적
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>본 사이트는 수집한 개인정보를 다음의 목적을 위해 활용합니다:</p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>문의 사항에 대한 답변 및 소통</li>
                  <li>서비스 개선 및 신규 서비스 개발을 위한 통계 분석</li>
                  <li>부정 이용 방지 및 서비스 안정성 확보</li>
                  <li>공지사항 전달 및 서비스 관련 안내</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                3. 개인정보의 보유 및 이용 기간
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>본 사이트는 원칙적으로 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.</p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>문의 내용: 문의 처리 완료 후 1년간 보관 후 파기</li>
                  <li>접속 로그 기록: 3개월 보관 후 자동 삭제</li>
                </ul>
                <p className="mt-3">단, 관련 법령에 의해 보존할 필요가 있는 경우 해당 법령에서 정한 기간 동안 보관합니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                4. 개인정보의 제3자 제공
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed">
                <p>본 사이트는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다:</p>
                <ul className="list-disc list-inside pl-4 space-y-1 mt-2">
                  <li>이용자가 사전에 동의한 경우</li>
                  <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                5. 개인정보의 파기 절차 및 방법
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p className="font-medium text-[#4a3f33]">가. 파기 절차</p>
                <p>이용자가 제공한 정보는 목적 달성 후 별도의 DB로 옮겨져 내부 방침 및 관련 법령에 따라 일정 기간 저장된 후 파기됩니다.</p>
                <p className="font-medium text-[#4a3f33] mt-3">나. 파기 방법</p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>전자적 파일 형태: 복구 불가능한 방법으로 영구 삭제</li>
                  <li>종이 문서: 분쇄기로 분쇄하거나 소각</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                6. 이용자의 권리와 행사 방법
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed">
                <p>이용자는 언제든지 다음과 같은 권리를 행사할 수 있습니다:</p>
                <ul className="list-disc list-inside pl-4 space-y-1 mt-2">
                  <li>개인정보 열람 요구</li>
                  <li>개인정보 정정 요구</li>
                  <li>개인정보 삭제 요구</li>
                  <li>개인정보 처리 정지 요구</li>
                </ul>
                <p className="mt-3">권리 행사는 아래 연락처로 서면, 전화, 이메일 등을 통해 하실 수 있습니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                7. 쿠키(Cookie)의 운영 및 거부
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>본 사이트는 이용자에게 최적화된 서비스를 제공하기 위해 쿠키를 사용할 수 있습니다.</p>
                <p className="font-medium text-[#4a3f33]">쿠키 거부 방법:</p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>웹브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보 메뉴에서 설정 가능</li>
                  <li>쿠키 저장을 거부할 경우 일부 서비스 이용에 어려움이 있을 수 있습니다</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                8. 개인정보 보호책임자
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed">
                <p className="mb-3">본 사이트는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제를 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                <div className="bg-[#faf8f3] border border-[#e8dfd0] rounded-lg p-4 space-y-1">
                  <p className="font-medium text-[#4a3f33]">개인정보 보호책임자</p>
                  <p>이메일: mgrn93@naver.com</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                9. 개인정보처리방침의 변경
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed">
                <p>본 개인정보처리방침은 법령, 정책 또는 보안기술의 변경에 따라 내용이 추가, 삭제 및 수정될 수 있으며, 변경 시에는 사이트 공지사항을 통해 고지할 것입니다.</p>
                <p className="mt-3 font-medium text-[#4a3f33]">공고일자: 2026년 1월 1일</p>
                <p className="font-medium text-[#4a3f33]">시행일자: 2026년 1월 1일</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#e8dcc8] py-8 px-6 mt-16">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-xs text-[#7a6d5f]">© 2026 게임기획자 해든의 낙서</p>
        </div>
      </footer>
    </div>
  );
}
